import http from './http-common';

class FabricQualityService {
  getAll() {
    return http.get('/fabricQuality');
  }

  getForList() {
    return http.get(`/fabricQuality/getFabricQualityForList`);
  }
  getList() {
    return http.get(`/fabricQuality/getFabricQualityList`);
  }

  create(data) {
    return http.post(`/fabricQuality/`, data);
  }
  update(id , data) {
    return http.put(`/fabricQuality/${id}`, data);
  }
  getDetailsById(fabricQualityID) {
    return http.get(`/fabricQuality/getDetails/${fabricQualityID}`);
  }
  
  getForListByWidth(Width = 0) {
    return http.get(`/fabricQuality/getFabricQualityDetails/${Width}`);
  }
  getFabricQualityForExportContract(id) {
    return http.get(`/fabricQuality/getFabricQualityForExportContract/${id}`);
  }
  getForCostingQualityGridChecker(fabricQualityID) {
    return http.get(`/fabricQuality/ForCostingQualityGridChecker/${fabricQualityID}`);
  }
  

  //   getYarnContractFabricQuality() {
  //     return http.get('/fabricQuality/yarnContractFabricQuality');
  //   }
}

export default new FabricQualityService();
